module.exports = __webpack_public_path__ + "static/media/map_icon_sprite.30075f48.png";